import { AppStateValue } from '../../AppState';
import { getCachedFeature } from '../../shared/cache/FeatureCache';
import { platformService } from '../../shared/services/platform.service';
import { LICENSE_FEATURE, TICKET_PAGINATION } from '../../shared/utils/constants';
import { BuildFilterQuery, objectFromSelectedFilters, prepareFiltersData } from '../List/TicketQueryHelper';
import { loadFilters } from '../ticketHelper';
import { getCustomViewDropdownFilters } from '../toolbar/CustomViewPopup/heplers/customPopupHelper';
export {
  buildSideViewSelectedTicketQuery,
  filterSideViewTicketsForUpdatedTicket,
  isCustomViewDriven
} from './sideViewTicketFilters';

const SIDE_VIEW_EXPAND =
  '$expand=TicketSlas($orderby=CreatedDate desc;$select=CreatedDate,ModifiedDate;$expand=SlaState,ServiceLevelAgreement($select=Name,IsActive,CreatedDate;$expand=SlaCriterias($select=Id,TimeDigitPart,TimeUnitPart,SlaActionTypeId,CreatedDate)))';

export const buildSideViewListQuery = async (page: number, filter: string, currentState:AppStateValue, sortedViews:any[], api: platformService, t:any, graphAPI:any, setState:any, currentUser:any): Promise<string> => {

  const isEnabled = await getCachedFeature(LICENSE_FEATURE.CustomViews);
  const getLocalCustomViewId = localStorage.getItem('selectedCustomViewId');
  if (isEnabled && getLocalCustomViewId) {
    const results = await Promise.all([
        ((currentState?.source?.length ?? 0) > 0) ? Promise.resolve(currentState) : loadFilters(api, graphAPI, currentState, setState)
      ]);
      
    const [_, defaultFilter] = await prepareFiltersData(results[0],currentState, t);
    
    let customView = sortedViews.find(x=>x.Id==getLocalCustomViewId) ?? null;
    
    if (customView){
      const customViewfilter = getCustomViewDropdownFilters(JSON.parse(JSON.stringify(defaultFilter)), customView.ViewFilters);
      const customFilters = objectFromSelectedFilters(customViewfilter, false);
      const query = BuildFilterQuery({
                      state: currentState,
                      currentUser,
                      filterObj: customFilters.customFilters,
                      childFiltervalues: customViewfilter,
                      expandedProperties: null,
                      valuesCustomViews: {
                        ModifiedDate: customView.ModifiedDate,
                        CreatedDate: customView.CreatedDate,
                        CustomValues: {},
                      },
                      includeCustomProperties: true,
                      isFromSideViewTickets: true,
                    });
      
      filter = [filter ?? "", query.main].filter(x => (x?.length ?? 0) > 0).join(' and ');
      filter = [filter ?? "", query.custom ? `cpfilter=${query.custom}` : ""].filter(x => (x?.length ?? 0) > 0).join('&');
    }
  }


  const top = TICKET_PAGINATION.ITEM_PER_PAGE();
  const skip = (page - 1) * top;
  const fullQuery = `$orderby=CreatedDate desc&$top=${top}&$count=true&$skip=${skip}&${SIDE_VIEW_EXPAND}`;
  const _filter =  filter ? `?$filter=${filter}&${fullQuery}` : `?${fullQuery}`;
  return _filter;
};
